<template>
  <div class="pt-10 cursor-pointer" @click="onClick(product)">
    <grey-container
      vertical
      rounded="12"
      classes="overflow-y-visible px-6 py-4 pointer-events-none w-full h-full"
    >
      <div
        class="relative w-auto mx-auto overflow-y-visible flex justify-center w-full h-full pt-10"
      >
        <ion-img
          :src="product.preview"
          class="absolute bottom-0 w-3/4 sm:w-1/2"
        />
      </div>
      <span class="font-helvetica-medium text-black text-16 mt-4">
        {{ product.name }}
      </span>
    </grey-container>
  </div>
</template>

<script>
import GreyContainer from "../../components/containers/GreyContainer.vue";

export default {
  name: "ProductsCategoryItem",

  components: {
    GreyContainer,
  },

  props: {
    product: {
      type: Object,
    },

    classRatio: {
      type: String,
      default: "",
    },

    onClick: {
      type: Function,
      default: () => {},
    },
  },
};
</script>
